<template>
  <div v-loading="loading">
    <el-input
      v-model="config.title"
      clearable=""
      style="margin-bottom:10px;"
      placeholder="请输入内容标题">
      <el-button
        slot="append"
        icon="el-icon-search"
        @click="fetch"></el-button>
    </el-input>
    <el-table
      :data="list"
      height="520px"
      border=""
      @row-click="selectitem">
      <el-table-column
        prop="title"
        label="内容标题"
        min-width="240"></el-table-column>
    </el-table>
    <pagination-new
      v-model="config"
      :total="total"
      :fetch="fetchList" />
  </div>
</template>
<script>
import Portal from '@/service/portal'
export default {
  name: 'MessageInfo',
  props: {
    linkType: { type: Number, default: 0 },
    contentTypes: { type: Array, default: () => [0] }
  },
  data() {
    return { loading: false, list: [], total: 0, config: { title: '', pageNum: 1, pageSize: 10 }}
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    fetch() {
      this.config.pageNum = 1
      this.fetchList()
    },
    selectitem(item) {
      this.$emit('select', { linkType: this.linkType, link: item.msgId, title: item.title, contentType: item.contentType })
    },
    fetchList() {
      this.loading = true
      Portal.getmessages({ ...this.config, contentTypes: this.contentTypes })
        .then(res => {
          const { result, message, records, total } = res.data
          this.loading = false
          if ([0].includes(result)) {
            this.list = records
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
